import React from "react";
import SingleBlog from "components/single-blog-card";
import { formatDate } from "helpers/formatDate";
import SwiperCore, { Scrollbar, Keyboard, Mousewheel } from "swiper";
import Card from "components/card";
import CenteredSlideshow, { Slide } from "components/centered-slideshow";
import "./style.scss";

const RecentNews = ({ data }) => {
  return (
    <div className="recent-news">
      <div className="mb-8 container">
        <div className="">
          <h2 className="header mb-2.5">{data.title}</h2>
          <p className="text-gray-700 font-montserrat font-medium text-lg sm:text-base">{data.description}</p>
        </div>
      </div>
      <div className="overflow-hidden container !max-w-[calc(100%-(100%-1280px)/2)] !mr-0 !pr-0 sm:ml-0 sm:pl-0">
        <CenteredSlideshow>
          {data?.news.map((blog, index) => (
            <Slide key={index}>
              <Card 
                link={`/content-hub/${blog.handle.current}`}
                Image={<div className="w-full h-[240px] overflow-hidden rounded"> <img src={blog.image.src} alt={blog.author} className="w-full h-full object-cover" /> </div>}
                authorImage={blog.authorImage.src}
                description={blog.description}
                author={blog.author}
                date={formatDate(blog.date)}
                title={blog.title}
              />
            </Slide>
          ))}
        </CenteredSlideshow>
      </div>
    </div>
  );
};

export default RecentNews;
